import {Input} from 'semantic-ui-react';
import styled from 'styled-components';

export const DeleteUserInput = styled(Input)`
  width: 240px;
`;
